import { getPensionLogos } from "@advisa/wallet/svg";

import capitalizeFirstLetter from "./capitalizeFirstLetter";

const SQUARE_LOGOS = getPensionLogos("square");

// `logotype` arrives from the API as an asset filename ("futurpension.png"), not a
// URL. The artwork ships inside the wallet package, so it has to be looked up by name.
export const getPensionLogo = (logotype?: string | null) => {
  const name = capitalizeFirstLetter(logotype ?? "").replace(".png", "");
  const normalized = name === "Futurpension" ? "Futur" : name;

  if (!normalized) {
    // `includes("")` matches every logo, so an empty name would pick an arbitrary one.
    return undefined;
  }

  return SQUARE_LOGOS.find((logo) => logo.name.includes(normalized));
};
